import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from "@spartacus/core";
import { IconModule, MediaModule } from "@spartacus/storefront";
import { KnBrCopyRightComponent } from "./kn-br-copy-right.component";
import { BrowserModule } from "@angular/platform-browser";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        UrlModule,
        I18nModule,
        BrowserModule,
        MediaModule,
        IconModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CarlisleFooterComponent: {
                    component: KnBrCopyRightComponent,
                },
            },
        } as CmsConfig),
        KnBrCopyRightComponent,
    ],
    exports: [KnBrCopyRightComponent],
})
export class KnBrCopyRightModule {}
